import { Pipe, PipeTransform } from '@angular/core';
import { Application } from '../models/application';

@Pipe({
  name: 'applicationSummary'
})
export class ApplicationSummaryPipe implements PipeTransform {

  transform(applications: Application[], filterText: string): unknown {
    if (!applications) return applications;
    if (applications.length === 0 || filterText === "") {
      return applications;
    } else {
      return applications.filter((application) => {
        return application.appName.toLowerCase().includes(filterText.toLowerCase())
      })
    }
  }

}
